exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-range-container {\n  display: inline-block;\n}\n\nmdl-textfield.number {\n  width: 80px;\n}\n\n", ""]);

// exports
